module.exports = __webpack_public_path__ + "static/media/mongodb.409452f1.svg";